<template>
  <div>
    <b-modal
      id="delete-users-group"
      hide-footer
      title="Revoke all users"
    >
      <h5>
        you sure you want to revoke all users from this group
      </h5>
      <div
        class="d-flex justify-content-center align-items-center"
        style="gap:10px"
      >
        <b-button
          style="flex:1"
          variant="outline-danger"
          @click="$bvModal.hide('delete-users-group')"
        >
          No
        </b-button>
        <b-button
          style="flex:1"
          variant="primary"
          :disabled="loadingDeleteBtn"
          @click="deleteUserFromGroup"
        >
          <b-spinner
            v-if="loadingDeleteBtn"
            small
          />
          <span v-else>Yes</span>

        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>

import { BModal, BButton, BSpinner } from 'bootstrap-vue'
import { ref } from '@vue/composition-api'

export default {
  components: {
    BModal, BButton, BSpinner,
  },
  props: {
    selectedUser: {
      type: String,
      default: undefined,
    },
  },
  setup(props, ctx) {
    const loadingDeleteBtn = ref(false)
    const deleteUserFromGroup = async () => {
      try {
        loadingDeleteBtn.value = true
        await ctx.root.$store.dispatch('groups/removeUserFromGroup', {
          body: {
            clear: true,
          },
          groupID: ctx.root.$route.query.id,
        })
        ctx.root.$bvModal.hide('delete-users-group')
        ctx.emit('deleted')
      } catch (error) {
        console.log(error)
      } finally {
        loadingDeleteBtn.value = false
      }
    }

    return {
      deleteUserFromGroup,
      loadingDeleteBtn,
    }
  },

}

</script>
